import createLucideIcon from '../createLucideIcon';

const BookCopy = createLucideIcon('BookCopy', [
  ['path', { d: 'M2,16V4c0-1.1,0.9-2,2-2h11', key: '1yd1ps' }],
  ['path', { d: 'M5,14H4c-1.1,0-2,0.9-2,2s0.9,2,2,2h1', key: '174709' }],
  ['path', { d: 'M22,18H11c-1.1,0-2,0.9-2,2l0,0', key: 'j7vrsj' }],
  [
    'path',
    { d: 'M11,6h11v16H11c-1.1,0-2-0.9-2-2V8C9,6.9,9.9,6,11,6z', key: '1vazy7' },
  ],
]);

export default BookCopy;
